export default __webpack_public_path__ + "static/media/grid_filter1.befe10ae.svg";